export const validationUser = (t: Function) => ({
  required: {
    value: true,
    message: t("Login.inputRequiredErrorMessage"),
  },
  pattern: {
    value: /^[\S][a-zA-Z0-9-_.]+@[\S][a-zA-Z0-9-_.]+\.[\S][a-zA-Z0-9-_.]+$/,
    message: t("Login.inputEmailFormatErrorMessage")
  },
  minLength: {
    value: 6,
    message: t("Login.inputMinLenghtSixCharactersErrorMessage"),
  },
  maxLength: {
    value: 80,
    message: t("Login.inputMaxLenghtEightyErrorMessage"),
  },
});

export const validationPassword = (t: Function) => ({
  required: {
    value: true,
    message: t("Login.inputRequiredErrorMessage"),
  },
  pattern: {
    value: /^[\S][a-zA-Z0-9#.!-_@]{0}/,
    message: t("Login.inputEmailFormatErrorMessage")
  },
  minLength: {
    value: 8,
    message: t("Login.inputMinLenghtEightCharactersErrorMessage"),
  },
  maxLength: {
    value: 16,
    message: t("Login.inputMaxLenghtErrorMessage"),
  },
});

// keyfilter={/^[a-zA-Z0-9]*$/}